import { SubscriptionType } from './fetch/fetchProductSubscriptionByRegion';

export const getOneOffFlexiblePrice = (
  subscriptions: SubscriptionType[],
  currentSubscription?: SubscriptionType
) => {
  const oneOffFlexibleSubscriptions = subscriptions.filter(
    item =>
      item.customerType === currentSubscription?.customerType &&
      item.isFlexible &&
      item.minDurationMonths === 1
  );
  return (
    oneOffFlexibleSubscriptions.find(item => item.isSpecialOffer)?.oneOffFee ??
    oneOffFlexibleSubscriptions?.[0]?.oneOffFee
  );
};
